import { render, staticRenderFns } from "./ingredientClass.vue?vue&type=template&id=820108ba&scoped=true&"
import script from "./ingredientClass.vue?vue&type=script&lang=js&"
export * from "./ingredientClass.vue?vue&type=script&lang=js&"
import style0 from "./ingredientClass.vue?vue&type=style&index=0&id=820108ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820108ba",
  null
  
)

export default component.exports